import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { clearAuthSession } from '../authSession';

const isAuthenticated = () => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  
  // Verificar que ambos tokens existen y no están vacíos
  if (!accessToken || !refreshToken || accessToken.trim() === '' || refreshToken.trim() === '') {
    return false;
  }
  
  try {
    // Verificar que el token no esté malformado (básico)
    const tokenParts = accessToken.split('.');
    if (tokenParts.length !== 3) {
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error validating token format:', error);
    return false;
  }
};

export const PrivateRoute = ({ element: Element }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateAuth = () => {
      const authenticated = isAuthenticated();
      setIsValid(authenticated);
      setIsValidating(false);
      
      // Si no está autenticado, limpiar cualquier token inválido
      if (!authenticated) {
        clearAuthSession();
      }
    };

    validateAuth();
  }, []);

  // Mostrar estado de carga durante la validación
  if (isValidating) {
    return (
      <div className="flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="loading"></div>
      </div>
    );
  }

  return isValid ? <Element /> : <Navigate to="/login" replace />;
};